module.exports = __webpack_public_path__ + "media/images/pages/fcr-case/case-4-0842935c5a222dafcf0c2ca6add3b89c.png";